const NETWORK_ERROR_PATTERNS = [
  "failed to fetch",
  "networkerror",
  "network error",
  "load failed",
  "the network connection was lost",
];

function isNetworkError(err: unknown): boolean {
  if (!(err instanceof TypeError)) return false;
  const msg = err.message.toLowerCase();
  return NETWORK_ERROR_PATTERNS.some((pattern) => msg.includes(pattern));
}

/**
 * Converts a raw stream error into a user-friendly Error.
 * Browsers mask network disconnections (e.g. from tab throttling) as
 * opaque TypeError / CORS-like errors. This detects those and returns
 * a clearer message so callers don't surface misleading CORS errors.
 */
export function toStreamError(err: unknown): Error {
  if (isNetworkError(err)) {
    return new Error(
      "Connection to the server was lost. This can happen when the browser tab is in the background. Please try again.",
    );
  }
  return err instanceof Error ? err : new Error(String(err));
}
